<template>
  <el-container class="home">
    <el-header class="header">
      <Header
        :slide-width="slideWidth"
        @menu-trigger-event="menuTriggerEvent"
      />
    </el-header>
    <el-container class="content">
      <el-aside :width="slideWidth">
        <SlideMenu :is-collapse="isCollapse" />
      </el-aside>
      <el-container>
        <tags-view />
        <el-main>
          <div class="breadcrumb">
            <!-- <el-button v-show="breadcrumbData.length>0" size="mini" @click="back()" icon="el-icon-back">返回</el-button> -->
            <el-breadcrumb separator="/">
              <el-breadcrumb-item
                v-for="(item, index) in breadcrumbData"
                :key="index"
              >
              {{ item}}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <router-view />
        </el-main>
        <el-footer>
          <Footer />
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import SlideMenu from '@/components/SlideMenu'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TagsView from '@/components/TagsView'
import { generateTitle } from '@/utils/i18n'

export default {
  name: 'Home',
  components: {
    SlideMenu,
    Header,
    Footer,
    TagsView
  },
    watch:{
  },
  data() {
    return {
      breadcrumbData: [],
      slideWidth: '200px',
      isCollapse: false,
    }
  },
  beforeUpdate() {
    const breadcrumbData = []
    const matcheds = this.$route.matched
    for (var i = 0; i < matcheds.length; i++) {
      const matched = matcheds[i]
      const meta = matched.meta
      if (!meta.title) {
        continue
      }
      const item = {
        title: meta.title
      }
      breadcrumbData.push(this.generateTitle(item.title))
    }
    let tempArr
    if(breadcrumbData[1].indexOf('+') != -1){
      tempArr=breadcrumbData[1].split('+')
      breadcrumbData.splice(1,1)
      tempArr.forEach(item=>{
        breadcrumbData.push(item)
      })
    }
    this.breadcrumbData = breadcrumbData
  },
  methods: {
    generateTitle,
    menuTriggerEvent: function(triggerType) {
      if (triggerType === 'close') {
        this.isCollapse = true
        this.slideWidth = '65px'
      } else {
        this.isCollapse = false
        this.slideWidth = '200px'
      }
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="less">
@import "./Home.less";
</style>



// WEBPACK FOOTER //
// src/views/Home.vue